/**
 * The docked player's DOM id. Lives in its own module because both `PlayerDock` (which owns the
 * element) and `ChapterList` (which must not scroll anything outside it) need the value, and
 * `PlayerDock` already imports `ChapterList` — importing back would close a cycle.
 */
export const PLAYER_DOCK_ID = 'quality-player-dock';
